import React from 'react';
import PropTypes from 'prop-types';
import { Expand } from '@sparefoot/react-core';
import { withShowHide } from '@sparefoot/react-core/decorators';

import { Button } from 'components/core/Button';
import { Card } from 'components/legacy/Card';
import { ReviewList } from 'components/review/ReviewList';
import { ReviewForm } from 'components/review/ReviewForm';
import { Image } from 'components/core/Image';
import NoReviewsImage from 'assets/images/facilitypage/user-computer.svg';

import './FacilityReviews.scss';

export const enhance = withShowHide('reviewForm');

const DEFAULT_REVIEWS = [];

export function FacilityReviews({
	reviews = DEFAULT_REVIEWS,
	facility,
	reviewPageNum,
	baseUrl,
	onCreateReview,
	source,
	onToggleReviewForm,
	reviewFormShowing,
}) {
	const hasVerifiedReviews = Array.isArray(reviews) && reviews.length > 0;

	return hasVerifiedReviews ? (
		<Card className="facility-reviews">
			<ReviewList
				reviews={reviews}
				facility={facility}
				currentPage={reviewPageNum}
				baseUrl={baseUrl}
			/>
			<div
				className="review-form-wrapper"
				id="leave-a-review"
			>
				<Button
					secondary
					className="toggle-review-form"
					onClick={onToggleReviewForm}
				>
					Leave a review of this facility
				</Button>
				<Expand showing={reviewFormShowing}>
					<div>
						<ReviewForm
							onSubmit={onCreateReview}
							source={source}
							facilityId={facility.id}
						/>
					</div>
				</Expand>
			</div>
		</Card>
	) : (
		<Card className="facility-reviews no-reviews">
			<Image
				className="no-reviews-img"
				src={NoReviewsImage}
				alt="No reviews"
			/>
			<div className="no-reviews-content">
				<p>No reviews found</p>
				<p>Be the first to leave a review!</p>
			</div>
			<div
				className="review-form-wrapper"
				id="leave-a-review"
			>
				<Button
					secondary
					className="toggle-review-form"
					onClick={onToggleReviewForm}
				>
					Leave a Review
				</Button>
				<Expand showing={reviewFormShowing}>
					<div>
						<ReviewForm
							onSubmit={onCreateReview}
							source={source}
							facilityId={facility.id}
						/>
					</div>
				</Expand>
			</div>
		</Card>
	);
}

FacilityReviews.propTypes = {
	reviews: PropTypes.arrayOf(PropTypes.object),
	facility: PropTypes.object.isRequired,
	reviewPageNum: PropTypes.number,
	baseUrl: PropTypes.string,
	onCreateReview: PropTypes.func,
	onToggleReviewForm: PropTypes.func,
	reviewFormShowing: PropTypes.bool,
	source: PropTypes.string,
};

export default enhance(FacilityReviews);
